import { makeStyles, MenuItem, Select } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(
  _ => ({
    menuItem: {
      "&.Mui-selected": {
        backgroundColor: "#0030FF !important",
        color: "white"
      },
      "&:hover": {
        backgroundColor: "#0030FF !important",
        color: "white"
      }
    },
    menuPaper: {
      "& ul": {
        gridRowGap: "0px !important",
        padding: "0 !important"
      },
      "&.MuiMenu-list": {
        padding: "0 !important"
      }
    },
    selectButton: {
      "& .MuiSelect-icon": {
        color: "#0030FF"
      },
      "& .MuiSelect-selectMenu": {
        padding: "3px 5px 5px 15px"
      },
      "&.MuiMenu-list": {
        padding: "0 !important"
      },
      "&:after": {
        borderBottom: "none"
      },
      "&:before": {
        borderBottom: "none !important"
      },
      "&:hover": {
        backgroundColor: "#F4F8FF",
        borderBottom: "none"
      },
      backgroundColor: "#F4F8FF",
      border: "4px solid #F4F8FF",
      borderRadius: "8px",
      color: "#0030FF",
      height: "50px",
      marginLeft: "20px",
      marginTop: "5px",
      width: "135px"
    }
  }),
  { name: "DropOffFilterSelect" }
);

export interface DropOffFilterSelectProps {
  filterOutletStatus: number;
  setFilterOutletStatus: React.Dispatch<React.SetStateAction<number>>;
}
const DropOffFilterSelect: React.FC<DropOffFilterSelectProps> = props => {
  const { filterOutletStatus, setFilterOutletStatus } = props;
  const classes = useStyles({});

  const handleChange = event => {
    setFilterOutletStatus(event.target.value);
  };

  return (
    <Select
      value={filterOutletStatus}
      onChange={handleChange}
      className={classes.selectButton}
      MenuProps={{
        classes: { paper: classes.menuPaper }
      }}
      variant="filled"
    >
      <MenuItem value="0" className={classes.menuItem}>
        All
      </MenuItem>
      <MenuItem value="1" className={classes.menuItem}>
        Unregistered
      </MenuItem>
      <MenuItem value="2" className={classes.menuItem}>
        Incomplete
      </MenuItem>
      <MenuItem value="3" className={classes.menuItem}>
        Registered
      </MenuItem>
    </Select>
  );
};

export default DropOffFilterSelect;
